/*
 * View for handling a list with selectable items
 */

define([
  "marionette",
  "modules/shared/selectableList/template/selectableListTemplate.html",
  "modules/shared/selectableList/template/selectableItemTemplate.html",
], function (Marionette, SelectableListTemplate, SelectableItemTemplate) {
  var SelectableListView = {};

  SelectableListView.selectableItem = Marionette.ItemView.extend({
    tagName: "li",
    template: SelectableItemTemplate,
    initialize: function (options) {
      //pass name attribute in
      this.nameAttribute = options.nameAttribute;
    },
    triggers: {
      click: "click:item",
    },
    modelEvents: {
      change: "render",
      enter: "render",
    },
    serializeData: function () {
      const data = this.constructor.__super__.serializeData.apply(this, arguments);
      if (this.nameAttribute != "name") {
        data.name = data[this.nameAttribute];
      }
      return data;
    },
    select: function () {
      this.$el.find("h4").addClass("selected");
    },
    unselect: function () {
      this.$el.find("h4").removeClass("selected");
    },
  });

  SelectableListView.selectableList = Marionette.CompositeView.extend({
    template: SelectableListTemplate,
    itemViewContainer: "ul",
    itemView: SelectableListView.selectableItem,
    initialize: function (options) {
      this.nameAttribute = options.nameAttribute;
    },
    collectionEvents: {
      sort: "render",
    },
    itemViewOptions: function () {
      //pass name attribute to the collection's children
      return {
        nameAttribute: this.nameAttribute,
      };
    },
  });

  return SelectableListView;
});
